import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {  FormControl, FormGroup,  Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from '../../alert/alert.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
declare var $: any;
import * as _ from 'lodash';
import { ChangeMasterService } from 'src/app/services/change-master.service';
@Component({
  selector: 'app-chg7',
  templateUrl: './chg7.component.html',
  styleUrls: ['./chg7.component.css']
})
export class Chg7Component implements OnInit {

  public environmentSettings: any;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfChargeMaster: DataTables.Settings = {};
  dtOptionsOfChargeMasterNew: DataTables.Settings = {};
  dtTriggerChargeMaster: Subject<any> = new Subject();
  dtTriggerChargeMasterNew: Subject<any> = new Subject();
  registerDirectorList: any[];
  data: any[];
  masterDirectorList: any[];

  chgForm: FormGroup;
  modForm: FormGroup;
  satForm: FormGroup;
  chgList: any = [];
  editChargeID: any = [];
  restrictTabFlag: boolean;
  editChargeData: any = [];
  dateOfCreationModel: any;
  dateOfRegistrationModel: any;
  dateOfCondonationModel: any;
  dateOfRegModification: any;
  dateOfModification: any;
  dateOfRegSatisfaction: any;
  dateOfSatisfaction: any;
  ismodified: boolean;
  issatisfied: boolean;
  disabledOnClick: boolean;

  constructor(private ChargeMasterService: ChangeMasterService, private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction, private customValidations: CustomValidation,
    private alert: AlertComponent,
    private router: Router, ) { }

  ngOnInit() {
  
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');
    this.chgForm = new FormGroup({
      chargeId: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9,. -]*$"), Validators.maxLength(10), this.customValidations.noWhitespaceValidator]),
      dateOfCreation: new FormControl('', [Validators.required]),
      dateOfRegistration: new FormControl('', []),
      shortDescriptionofproperty: new FormControl('', [Validators.pattern("^[a-zA-Z0-9\"\,+.&()%/\n' -]*$"), Validators.maxLength(350)]),
      periodSecured: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,.&' -]*$"), Validators.maxLength(20)]),
      amountSecured: new FormControl('', [Validators.required, Validators.pattern("^[0-9,./-]*$"), Validators.maxLength(20), this.customValidations.noWhitespaceValidator]),
      nameChargeHolder: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9,.&' -]*$"), Validators.maxLength(50), this.customValidations.noWhitespaceValidator]),
      addressChargeHolder: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,.&'/%\"\() \n-]*$"), Validators.maxLength(250)]),
      termsandCondition: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,;:.&'%/+=\"\()\n -]*$"), Validators.maxLength(5000)]),
      descriptionOfInstrument: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,.\n&/%'\"\() -]*$"), Validators.maxLength(5000)]),
      factsOfCondonation: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,.&' -]*$"), Validators.maxLength(250)]),
      dateOfCondonation: new FormControl('', []),
      reasonsForDelay: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,\"\./%&()'\n -]*$"), Validators.maxLength(250)]),

    })
   
    this.modForm = new FormGroup({
      dateOfModification: new FormControl('', []),
      dateOfRegModification: new FormControl('', []),
      descOfInstrumentModifying: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,.&'/%\"\() -]*$"), Validators.maxLength(500)]),
      particularsOfMod: new FormControl('', [Validators.pattern("^[a-zA-Z0-9,.&'/%\"\() -]*$"), Validators.maxLength(350)]),
      amountOfCharge: new FormControl('', [Validators.pattern("^[0-9,./-]*$"), Validators.maxLength(20)]),
    })

    this.satForm = new FormGroup({
      dateOfSatisfaction: new FormControl('', []),
      dateOfRegSatisfaction: new FormControl('', []),
    })

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabFlag = true;
        this.issatisfied = false;
        this.ismodified = false;

        this.editChargeID = params['particularId'];
        this.getBankChargeMasterById(this.editChargeID);
      } else {
        this.restrictTabFlag = false;
        this.issatisfied = false;
        this.ismodified = false;
      }
       this.dtTriggerChargeMasterNew.next();
    })

    this.dtOptionsOfChargeMasterNew = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order:[0],
     // order:[0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [7] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Charge Master',
          title: 'Charge Master',
          extend: 'excel',
          exportOptions: {
            columns: [1, 3, 4, 5, 6],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    
   // this.getRegisterDirectorList();
  }

  // adjustdirectormasterTable() {
  //   var directorData = this.registerDirectorList;
  //   if (directorData.length) {
  //     this.registerDirectorList = [];
  //     $("#chargeMasterTable").DataTable().destroy();
  //     this.registerDirectorList = directorData;
  //     this.dtTriggerChargeMasterNew.next();
     
  //       $("#chargeMasterTable").DataTable().columns.adjust().draw();
     
  //   }
  // }

  // tabRegisterOfDirectorOnClickEvent() {
   
  //     $("#chargeMasterTable").DataTable().columns.adjust().draw();
    
  // }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['chg7List']  } }],
      { relativeTo: this.activatedRoute.parent });
  }

  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.ChargeMasterService.getChargeMaster({ isSearch: false }).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      console.log("******datacheck", this.registerDirectorList);
      this.dtTriggerChargeMasterNew.next();
      
    });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  saveFormEntryCreation() {
    this.disabledOnClick = true;
    this.restrictTabFlag = true;
    var object = {
      chargeId: this.chgForm.controls.chargeId.value,
      dateOfCreation: this.setDate(this.chgForm.controls.dateOfCreation.value),
      dateOfRegistration: this.setDate(this.chgForm.controls.dateOfRegistration.value),
      shortDescriptionofproperty: this.chgForm.controls.shortDescriptionofproperty.value,
      periodSecured: this.chgForm.controls.periodSecured.value,
      amountSecured: this.chgForm.controls.amountSecured.value,
      nameChargeHolder: this.chgForm.controls.nameChargeHolder.value,
      addressChargeHolder: this.chgForm.controls.addressChargeHolder.value,
      termsandCondition: this.chgForm.controls.termsandCondition.value,
      descriptionOfInstrument: this.chgForm.controls.descriptionOfInstrument.value,
      factsOfCondonation: this.chgForm.controls.factsOfCondonation.value,
      dateOfCondonation: this.setDate(this.chgForm.controls.dateOfCondonation.value),
      reasonsForDelay: this.chgForm.controls.reasonsForDelay.value,
    }
    this.ChargeMasterService.saveChargeCreationData(object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message);
        this.restrictTabFlag = true;
        this.editChargeID = response.data._id;
      } else {
        this.restrictTabFlag = false;
        // this.alert.error(response.message);
        if(response.err_fields){
          this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
       this.dtTriggerChargeMasterNew.next();
    })
  }

  showFormEntryModification() {
    this.disabledOnClick = true;
    var modificationobject = {
      dateOfModification: this.setDate(this.modForm.controls.dateOfModification.value),
      dateOfRegModification: this.setDate(this.modForm.controls.dateOfRegModification.value),
      descOfInstrumentModifying: this.modForm.controls.descOfInstrumentModifying.value,
      particularsOfMod: this.modForm.controls.particularsOfMod.value,
      amountOfCharge: this.modForm.controls.amountOfCharge.value,
      particularId: this.editChargeID

    }

    this.ChargeMasterService.updateChargeModificationData(modificationobject).subscribe(response => {
      this.disabledOnClick = false;
      this.ismodified = true;
      if (response.status == 0) {
        this.alert.success(response.message);
        this.ismodified = true;
      } else {
        // this.alert.error(response.message);
        // if(response.err_fields){
        //   this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        // }else{
          // this.alert.error(response.message);
          console.log("************response*",response)
          if(response.err_fields){
            
            this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
          }else{
            this.alert.error(response.message);
          // }
        }
      }
      this.dtTriggerChargeMasterNew.next();
    })
    this.dtTriggerChargeMasterNew.next();
  }

  showFormEntrySatisfaction() {
    this.disabledOnClick = true;
    var satisfactionobject = {
      dateOfSatisfaction: this.setDate(this.satForm.controls.dateOfSatisfaction.value),
      dateOfRegSatisfaction: this.setDate(this.satForm.controls.dateOfRegSatisfaction.value),
      particularId: this.editChargeID
    }
    this.ChargeMasterService.updateChargeSatisfactionData(satisfactionobject).subscribe(response => {
      this.disabledOnClick = false;
      this.issatisfied = false;
      if (response.status == 0) {
        this.issatisfied = true;
        this.alert.success(response.message);
      } else {
        // this.alert.error(response.message);
        if(response.err_fields){
          this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
      // this.dtTriggerChargeMasterNew.next();
    })
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }



  getBankChargeMasterById(chgId) {
   this.registerDirectorList = [];
   
    this.ChargeMasterService.getChargeMasterById(chgId).subscribe(response => {
      console.log("**[0]****datacheck", response.data[0].ModificationHistory);
      console.log("**[0]**ModificationHistory**datacheck", response.data[0].ModificationHistory);
      this.editChargeData = response.data[0];
      this.registerDirectorList =response.data[0].ModificationHistory
      // var data = this.registerDirectorList.shift()
      $("#modificationHistoryTable").DataTable().destroy();
      this.data=[];
      var check = this.registerDirectorList .slice(1);
      console.log("****check**newarray", check);
      this.data = check.reverse();
      //this.dtTriggerChargeMasterNew.next();
      console.log("******newarray", this.data);


      this.chgForm.controls.chargeId.setValue(this.editChargeData.chargeId);
      this.chgForm.controls.dateOfCreation.setValue(this.editChargeData.dateOfCreation);
      this.chgForm.controls.dateOfRegistration.setValue(this.editChargeData.dateOfRegistration);
      this.chgForm.controls.shortDescriptionofproperty.setValue(this.editChargeData.shortDescriptionofproperty);
      this.chgForm.controls.periodSecured.setValue(this.editChargeData.periodSecured);
      this.chgForm.controls.amountSecured.setValue(this.editChargeData.amountSecured);
      this.chgForm.controls.nameChargeHolder.setValue(this.editChargeData.nameChargeHolder);
      this.chgForm.controls.addressChargeHolder.setValue(this.editChargeData.addressChargeHolder);
      this.chgForm.controls.termsandCondition.setValue(this.editChargeData.termsandCondition);
      this.chgForm.controls.descriptionOfInstrument.setValue(this.editChargeData.descriptionOfInstrument);
      this.chgForm.controls.factsOfCondonation.setValue(this.editChargeData.factsOfCondonation);
      this.chgForm.controls.dateOfCondonation.setValue(this.editChargeData.dateOfCondonation);
      this.chgForm.controls.reasonsForDelay.setValue(this.editChargeData.reasonsForDelay);



      if (this.editChargeData.dateOfCreation != null) {
        let dt = new Date(this.setFormatDate(this.editChargeData.dateOfCreation));
        this.dateOfCreationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

      if (this.editChargeData.dateOfRegistration != null) {
        let dt = new Date(this.setFormatDate(this.editChargeData.dateOfRegistration));
        this.dateOfRegistrationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

      if (this.editChargeData.dateOfCondonation != null) {
        let dt = new Date(this.setFormatDate(this.editChargeData.dateOfCondonation));
        this.dateOfCondonationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }


      // modification
      if (this.editChargeData.modification) {
        this.ismodified = true;
        this.modForm.controls.amountOfCharge.setValue(this.editChargeData.modification.amountOfCharge)
        this.modForm.controls.particularsOfMod.setValue(this.editChargeData.modification.particularsOfMod)
        this.modForm.controls.descOfInstrumentModifying.setValue(this.editChargeData.modification.descOfInstrumentModifying)

        if (this.editChargeData.modification.dateOfRegModification != null) {
          let dt = new Date(this.setFormatDate(this.editChargeData.modification.dateOfRegModification));
          this.dateOfRegModification = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editChargeData.modification.dateOfModification != null) {
          let dt = new Date(this.setFormatDate(this.editChargeData.modification.dateOfModification));
          this.dateOfModification = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      } else {
        this.ismodified = false;
      }

      // satisfaction
      if (this.editChargeData.satisfaction) {
        this.issatisfied = true;
        if (this.editChargeData.satisfaction.dateOfSatisfaction != null) {
          let dt = new Date(this.setFormatDate(this.editChargeData.satisfaction.dateOfSatisfaction));
          this.dateOfSatisfaction = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editChargeData.satisfaction.dateOfRegSatisfaction != null) {
          let dt = new Date(this.setFormatDate(this.editChargeData.satisfaction.dateOfRegSatisfaction));
          this.dateOfRegSatisfaction = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      } else {
        this.issatisfied = false;
      }
       this.dtTriggerChargeMasterNew.next();

    })
  }

  updateChargeMaster(_id) {
    this.disabledOnClick = true;
    var object = {
      chargeId: this.chgForm.controls.chargeId.value,
      dateOfCreation: this.setDate(this.chgForm.controls.dateOfCreation.value),
      dateOfRegistration: this.setDate(this.chgForm.controls.dateOfRegistration.value),
      shortDescriptionofproperty: this.chgForm.controls.shortDescriptionofproperty.value,
      periodSecured: this.chgForm.controls.periodSecured.value,
      amountSecured: this.chgForm.controls.amountSecured.value,
      nameChargeHolder: this.chgForm.controls.nameChargeHolder.value,
      addressChargeHolder: this.chgForm.controls.addressChargeHolder.value,
      termsandCondition: this.chgForm.controls.termsandCondition.value,
      descriptionOfInstrument: this.chgForm.controls.descriptionOfInstrument.value,
      factsOfCondonation: this.chgForm.controls.factsOfCondonation.value,
      dateOfCondonation: this.setDate(this.chgForm.controls.dateOfCondonation.value),
      reasonsForDelay: this.chgForm.controls.reasonsForDelay.value,
    }
    this.ChargeMasterService.updateChargeMaster(object, this.editChargeID).subscribe(response => {
      console.log("responseresponseresponse",response);
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        // this.alert.error(response.message);
        if(response.err_fields){
          this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
      this.dtTriggerChargeMasterNew.next();
    })
    this.dtTriggerChargeMasterNew.next();
  }

  generateOutput() {
    var object = {
      id: this.editChargeID,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.ChargeMasterService.generateChargeMaster(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editChargeID);
          setTimeout(function () {
            self.downloadPdfDocument(self.editChargeID);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.ChargeMasterService.downloadChargeMasterFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.ChargeMasterService.downloadChargeMasterPdfFile(id, 'Single');
  }
}
